// extracted by mini-css-extract-plugin
export default {"trash":"FooterTrash_trash__24LUB","trash--hidden":"FooterTrash_trash--hidden__t4RZ+","trash--over":"FooterTrash_trash--over__J+TxN"};